/* <anreise-regionen> — Region-Chips schalten den passenden Readout (Fahrzeit /
   Distanz / Route) UND die aktive Route auf der Karte. Kein IP, keine
   Geolokalisierung: der Nutzer wählt aktiv. Progressive Enhancement: erster
   Readout + erste Route sind serverseitig aktiv; ohne JS zeigt <noscript> alle Readouts. */
if (!customElements.get('anreise-regionen')) {
  customElements.define('anreise-regionen', class extends HTMLElement {
    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('[data-anreise-chip]'));
      this.readouts = Array.from(this.querySelectorAll('[data-anreise-readout]'));
      this.nodes = Array.from(this.querySelectorAll('[data-anreise-node]'));
      this.routes = Array.from(this.querySelectorAll('[data-anreise-route]'));
      if (!this.chips.length) return;

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => this.select(chip.dataset.anreiseChip));
        chip.addEventListener('keydown', (e) => this.onKey(e));
      });

      // Karten-Orte sind ebenfalls anklickbar (Maus-Enhancement; Chips bleiben die A11y-Steuerung)
      this.nodes.forEach((node) => {
        node.addEventListener('click', () => this.select(node.dataset.anreiseNode));
      });

      const active = this.chips.find((c) => c.getAttribute('aria-pressed') === 'true');
      this.select((active || this.chips[0]).dataset.anreiseChip);
    }

    select(id) {
      this.chips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.anreiseChip === id)));
      this.readouts.forEach((r) => { r.hidden = r.dataset.anreiseReadout !== id; });
      this.nodes.forEach((n) => n.classList.toggle('is-active', n.dataset.anreiseNode === id));
      this.routes.forEach((r) => r.classList.toggle('is-active', r.dataset.anreiseRoute === id));
    }

    onKey(e) {
      const i = this.chips.indexOf(e.target);
      if (i < 0) return;
      let next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % this.chips.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + this.chips.length) % this.chips.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = this.chips.length - 1;
      if (next === null) return;
      e.preventDefault();
      const target = this.chips[next];
      target.focus();
      this.select(target.dataset.anreiseChip);
    }
  });
}
